import { RequestConfig } from '~/common/services/requests';
import {
  PlatformRequestOptions,
  useRequests,
} from '../../../contexts/RequestsContext';
import { useEventHandler } from '../../../hooks/useEventHandler';
import { ConstructDelete } from '../../types/ConstructDelete';
import { ConstructGet } from '../../types/ConstructGet';
import { ConstructPatch } from '../../types/ConstructPatch';
import { ConstructPost } from '../../types/ConstructPost';
import { constructDeleteRequest } from './logic/constructDeleteRequest';
import { constructGetRequest } from './logic/constructGetRequest';
import { constructPatchRequest } from './logic/constructPatchRequest';
import { constructPostRequest } from './logic/constructPostRequest';

type UseRequestConstructorReturn = {
  constructDelete: ConstructDelete;
  constructGet: ConstructGet;
  constructPatch: ConstructPatch;
  constructPost: ConstructPost;
};

export const useRequestConstructor = (): UseRequestConstructorReturn => {
  const { platformRequest } = useRequests();

  const constructDelete = useEventHandler(
    async <ResponseType>(
      deletePath: string,
      config?: RequestConfig,
      options?: PlatformRequestOptions,
    ) =>
      constructDeleteRequest<ResponseType>(
        platformRequest,
        deletePath,
        config,
        options,
      ),
  );
  const constructGet = useEventHandler(
    async <ResponseType>(
      getPath: string,
      config?: RequestConfig,
      options?: PlatformRequestOptions,
    ) =>
      constructGetRequest<ResponseType>(
        platformRequest,
        getPath,
        config,
        options,
      ),
  );
  const constructPatch = useEventHandler(
    async <ResponseType>(
      patchPath: string,
      config: RequestConfig,
      options?: PlatformRequestOptions,
    ) =>
      constructPatchRequest<ResponseType>(
        platformRequest,
        patchPath,
        config,
        options,
      ),
  );
  const constructPost = useEventHandler(
    async <ResponseType>(
      postPath: string,
      config?: RequestConfig,
      options?: PlatformRequestOptions,
    ) =>
      constructPostRequest<ResponseType>(
        platformRequest,
        postPath,
        config,
        options,
      ),
  );

  return {
    constructDelete,
    constructGet,
    constructPatch,
    constructPost,
  };
};
